import ViewController from "core/views/view.controller";
import _ from "lodash/lodash";

export default class ChartWorkloadColorsCtrl extends ViewController {
    static $inject = ['$scope'];

    constructor() {
        super(...arguments);

        this.colors = [];

        // Bindings
        this.workloads = [];
    }

    set workloads(workloads) {
        if (!workloads) {
            this.colors = [];
            return;
        }

        if (Array.isArray(workloads)) {
            if (workloads.length > 0) {
                this.colors = _(workloads.colors)
                    .map(workload => workload.color)
                    .value();
            } else {
                this.colors = [];
            }

        } else {
            this.colors = workloads.colors;
        }
    }
}



// WEBPACK FOOTER //
// ./src/modules/main/components/chart-workload-colors/chart-workload-colors.controller.js